import NextLink from 'next/link';
import { ComponentProps, forwardRef } from 'react';

export const RouterLink = forwardRef<
	HTMLAnchorElement,
	ComponentProps<typeof NextLink>
>(({ children, ...rest }, ref) => (
	// We encountered a strange bug related to https://github.com/vercel/next.js/discussions/50958
	// Therefore we decided to disable prefetch
	<NextLink prefetch={false} ref={ref} {...rest}>
		{children}
	</NextLink>
));
